document.addEventListener('DOMContentLoaded', (event) => {
  document.querySelectorAll('.print_btn').forEach((print_btn) => {
    print_btn.addEventListener('click', () => {
      // Get the content you want to print
      const articleTemplate = document.querySelector('.article-template');
      let content = articleTemplate.innerHTML;

      // Create a hidden iframe
      const iframe = document.createElement('iframe');
      iframe.style.position = 'absolute';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = 'none';
      iframe.style.left = '-9999px';
      document.body.appendChild(iframe);

      // Fix image paths and ensure they load before printing
      const fixImagePaths = (html) => {
        const baseUrl = window.location.origin;
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Process all images
        doc.querySelectorAll('img').forEach((img) => {
          // Handle Shopify's lazy loading
          if (img.hasAttribute('data-src')) {
            img.src = img.dataset.src;
          }

          // Convert relative paths to absolute
          if (!img.src.startsWith('http')) {
            img.src = `${baseUrl}${img.src.startsWith('/') ? '' : '/'}${img.src}`;
          }

          // Remove lazy loading attributes
          img.removeAttribute('loading');
          img.removeAttribute('data-src');
        });

        return doc.body.innerHTML;
      };

      content = fixImagePaths(content);

      // Get all styles from the main document
      const styles = Array.from(document.styleSheets)
        .map((styleSheet) => {
          try {
            if (styleSheet.href) {
              return `<link rel="stylesheet" href="${styleSheet.href}">`;
            } else {
              // For inline styles
              return `<style>${Array.from(styleSheet.cssRules)
                .map((rule) => rule.cssText)
                .join('')}</style>`;
            }
          } catch (e) {
            // Handle CORS issues
            return '';
          }
        })
        .join('');

      // Add print-specific styles
      const printStyles = `
          <style>
            @media print {
              body { visibility: visible !important; }
              img { max-width: 100% !important; }
              * {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
              }
            }
          </style>
        `;

      // Write to iframe
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(`
          <html>
            <head>
              <title>${document.title}</title>
              ${styles}
              ${printStyles}
            </head>
            <body>
              ${content}
              <script>
                // Force images to load before printing
                window.addEventListener('load', function() {
                  setTimeout(function() {
                    window.print();
                    window.addEventListener('afterprint', function() {
                      window.parent.postMessage('removePrintIframe', '*');
                    });
                  }, 500);
                });
              </script>
            </body>
          </html>
        `);
      iframeDoc.close();

      // Listen for message to remove iframe after printing
      window.addEventListener('message', function (e) {
        if (e.data === 'removePrintIframe') {
          document.body.removeChild(iframe);
        }
      });
    });
  });
});
